module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAGFBMVEUAAAD///////////////////////////8jfp1fAAAAB3RSTlMAFdTEtbQWNM07rgAAADZJREFUOMtjGNpA2AG7OKO6AXYJoSIBHBoURzWQr4EZoQFTgjSjGIRGtVBPiwEOLckBDEMSAAAqew7X/+st8AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icon_dark_goBack.png
// module id = 239
// module chunks = 1